import { getlocalStorageLogin } from "common/components/apiConfig";

export const getDataInLocalstorage = (key) => {
	const adminObj = getlocalStorageLogin();
	if (!adminObj?.user) {
		return null;
	}

	let { user } = adminObj;
	let userPars = user;
	return userPars;
};
